module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-calendar.d945ba32.png";